// src/config/i18n.js
// 当 localStorage.getItem('lang') === '2' 时返回英文，否则返回中文

const translations = {
  '添加楼层':'Add Floor',
  '添加需要管理员权限':'Admin only',
  '删除需要管理员权限':'Admin only',
  '请先输入楼层名称':'Enter floor name first',
  '添加楼层失败':'Add floor failed',
  '修改楼层信息失败':'Change floor failed',
  '删除楼层失败':'Del floor failed',
  '获取楼层数据失败，请点击左上角刷新按钮':'Get floor data failed, click refresh',
  '您确定要删除此楼层吗？':'Delete this floor?',
  '楼层信息':'Floor Info',
  '备注信息':'Note Info',
  '请输入楼层名称':'Enter floor name',

  // ==================== 通用 ====================
  '收起':'Collapse',
  '展开':'Expand',
  '保存':'Save',
  '退出':'Cancel',
  '取消':'Cancel',
  '确定':'Confirm',
  '编辑':'Edit',
  '删除':'Del',
  '上传':'Upload',
  '操作':'Action',
  '提示':'Prompt',
  '备注':'Note',
  '名称':'Name',
  '编号':'No.',
  '请选择':'Select',
  '请输入':'Enter',
  '图片路径':'Img URL',
  'URL路径':'URL',
  '左边距离':'Left',
  '顶部距离':'Top',
  '距离':'Dist',
  '项目名称':'Project',
  '背景颜色':'Bg Color',
  '系统语言':'Language',
  '默认':'Default',
  '白色':'White',
  '中文':'CN',
  '英文':'EN',
  '账号名称':'Account',
  '用户名':'User',
  '旧密码':'Old Pwd',
  '新密码':'New Pwd',
  '管理系统':'Mgmt Sys',
  '能源系统':'Energy Sys',
  '节能系统':'Energy Sys',
  '后台管理-登录':'Admin Login',
  '重置':'Reset',
  '后台登录':'Admin Login',
  '记住账号和密码':'Remember',
  '密码':'Pwd',
  '请输入用户名':'Enter user',
  '请输入密码':'Enter pwd',
  '正在加载中...':'Loading...',
  '时间筛选：':'Time Filter:',
  '导出数据':'Export Data',
  '楼栋名称':'Bldg Name',
  '楼层名称':'Floor Name',
  '房间名称':'Room Name',
  '设备id':'Dev ID',
  '上报时间':'Report Time',
  '上报类型':'Report Type',
  '上报内容':'Report Content',
  '电量':'Energy',
  '插卡状态':'Card Status',
  '控制日志':'Ctrl Log',
  '月':'M',
  '日':'D',
  '弹出加载框':'Show loading',
  '拿到设备日志信息':'Got device log info',
  '获取房间数据失败':'Get room data failed',
  '登录失败':'Login Fail',
  '登录失败,获取配置文件出错,请刷新游览器后重试':'Login fail, config error',
  '修改成功':'Saved',
  '修改失败':'Save fail',
  '操作成功':'Done',
  '操作失败':'Fail',
  '请先输入用户名':'Enter user first',
  '请先输入名称':'Enter name first',
  '请先输入旧密码':'Enter old pwd first',
  '请先输入新密码':'Enter new pwd first',
  '确认关闭？':'Close?',
  '您确认要退出吗？':'Logout?',
  '修改密码成功':'Pwd changed',
  '修改密码失败':'Pwd change fail',
  '上传成功':'Uploaded',
  '上传失败':'Upload fail',
  '复制':'Copy',
  '已复制':'Copied',
  '复制失败，请手动复制':'Copy fail',
  '机器码已复制':'Code copied',
  '系统未激活，请先激活':'Activate first',
  '网络连接失败，请检查网络设置':'Network error',
  '获取激活状态失败，服务器异常':'Server error',
  '请输入注册码':'Enter code',
  'API 地址错误':'API error',
  '激活失败':'Activate fail',
  '网络请求失败，请重试':'Retry',
  '注册码已过期，需要重新激活':'License expired',
  '检测到硬件变更，需要重新激活':'HW changed',
  '获取机器码':'Get Code',
  '粘贴注册码':'Paste Code',
  '完成激活':'Complete',
  '新的机器码':'New Code',
  '您的机器码':'Your Code',
  '新注册码':'New License',
  '注册码':'License',
  '重新激活':'Reactivate',
  '验证并激活':'Verify',
  '请联系管理员获取帮助':'Contact admin',
  '注册码已过期':'Expired',
  '需要重新激活':'Reactivate',
  '系统激活':'Activation',
  '您的注册码已超出授权有效期，请重新激活':'License expired',
  '硬件配置发生变化，请使用新机器码重新激活':'HW changed, reactivate',
  '请完成以下步骤激活您的系统':'Activate your system',
  '请将管理员提供的新注册码粘贴到此处...':'Paste new license...',
  '请将从管理员处获取的注册码粘贴到此处...':'Paste license...',
  '背景':'Bg',
  '语言':'Lang',

  '绑定设备':'Link Device',
  '已关联设备':'Linked',
  '未关联设备':'Unlinked',
  '请选择所属区域':'Select area',
  '请输入设备名称':'Enter dev name',
  '请输入 wg_mac':'Enter wg_mac',
  '设备名称':'Dev Name',
  'MAC 地址':'MAC',
  '所属区域':'Area',
  '占比(%)':'Ratio(%)',
  '已选':'Selected',
  '台设备':'dev(s)',
  '已关联':'Linked',

  '充值二维码':'Recharge QR Code',
  '正在生成二维码...':'Generating QR code...',
  '扫码访问充值页面':'Scan to visit recharge page',
  '下载二维码':'Download QR Code',
  '二维码生成失败':'QR code generation failed',

  '添加公司':'Add Company',
  '编辑公司信息':'Edit Company',
  '公司名称':'Company Name',
  '请输入公司名称':'Enter company name',
  '计费开关':'Billing Switch',
  '18:00-9:00不停机':'18:00-9:00 No Stop',
  '不停机':'No Stop',
  '欠费额度':'Arrears Limit',
  '欠费额度(元)':'Arrears Limit(¥)',
  '请输入欠费额度':'Enter arrears limit',
  '提醒阈值':'Alert Threshold',
  '提醒阈值(元)':'Alert Threshold(¥)',
  '请输入提醒阈值':'Enter alert threshold',
  '扣费方式':'Deduction Mode',
  '全天':'All Day',
  '时段1':'Period1',
  '时段2':'Period2',
  '时段3':'Period3',
  '金额必须为数字':'Amount must be numeric',
  '取消添加':'Cancel Add',
  '取消修改':'Cancel Edit',
  '保存添加':'Save Add',
  '保存修改':'Save Edit',
  '添加失败，请稍后重试':'Add failed, retry later',
  '修改失败，请稍后重试':'Edit failed, retry later',

  '网关MAC':'GW MAC',
  '网关IP':'GW IP',
  '网关状态':'GW Status',
  '网关状态：':'GW Status:',
  '选择楼层':'Select Floor',
  '选择房间':'Select Room',
  '获取房间数据失败，请点击左上角刷新按钮':'Get room data failed, click refresh',
  '获取数据失败,请点击左上角刷新按钮':'Get data failed, click refresh',
  '获取区域数据失败，请点击左上角刷新按钮':'Get area data failed, click refresh',
  '获取单元数据失败':'Get unit data failed',
  '获取楼层数据失败':'Get floor data failed',
  '获取设备信息失败':'Get device info failed',
  '获取公司数据失败，请点击左上角刷新按钮':'Get company data failed, click refresh',
  '获取小区数据失败':'Get area data failed',
  '获取楼栋数据失败':'Get building data failed',
  '编辑需要管理员权限':'Admin only',
  '确认删除该公司？删除后将同时删除关联的停机设备，此操作不可恢复！':'Confirm delete this company? Associated stopped devices will also be deleted, this cannot be undone!',
  '警告':'Warning',
  '删除失败':'Delete failed',
  '充值成功，请等待几秒':'Recharge successful, please wait a few seconds',
  '充值失败，请稍后重试':'Recharge failed, please retry later',
  '确认退租？退租后将清除该公司的余额数据，此操作不可恢复！':'Confirm terminate lease? Company balance will be cleared, this cannot be undone!',
  '清除数据成功':'Data cleared',
  '清除数据失败，请稍后重试':'Clear data failed, please retry later',
  '绑定设备需要管理员权限':'Admin only',
  '绑定设备成功':'Device linked',
  '绑定设备失败':'Link device failed',
  '是否停机':'Stop Status',
  '已停机':'Stopped',
  '未停机':'Not Stopped',
  '剩余金额':'Remaining Amount',
  '关联设备':'Linked Device',
  '关联设备筛选':'Device Filter',
  '新增公司':'Add Company',
  '二维码':'QR Code',
  '充值':'Recharge',
  '充值数据':'Recharge Data',
  '充值金额：':'Recharge Amount:',
  '退租':'Terminate Lease',
  '添加成功':'Added',
  '添加网关失败':'Add GW failed',
  '修改网关信息失败':'Change GW failed',
  '删除成功':'Deleted',
  '删除网关失败':'Del GW failed',
  '请先输入网关MAC':'Enter GW MAC first',

  '网关信息':'GW Info',
  '网关MAC：':'GW MAC:',
  '请输入网关MAC':'Enter GW MAC',
  '备注信息：':'Note:',
  '网关控制日志':'GW Ctrl Log',
  '区域信息':'Area Info',
  '所属小区：':'Area:',
  '所属单元：':'Unit:',
  '查询':'Query',
  '添加网关':'Add GW',

  '添加用户':'Add User',
  '用户信息':'User Info',
  '用户名称：':'User Name:',
  '用户名称':'User Name',
  '请输入用户名称':'Enter user name',
  '用户密码：':'User Pwd:',
  '请输入用户密码':'Enter user pwd',
  '用户管理：':'User Mgmt:',
  '权限管理：':'Auth Mgmt:',
  '输入关键字进行过滤':'Filter by keyword',
  '您确定要删除此用户吗？':'Delete this user?',
  '超级管理员':'Super Admin',
  '设备管理员':'Device Admin',
  '房间管理员':'Room Admin',
  '楼层管理员':'Floor Admin',
  '楼栋管理员':'Bldg Admin',
  '所有功能':'All Func',
  '只能控制':'Ctrl Only',
  '只能查看':'View Only',
  '请先输入用户名称':'Enter user name first',
  '添加用户失败':'Add user failed',
  '修改用户信息失败':'Change user failed',
  '删除用户失败':'Delete user failed',
  '区域管理员':'Area Admin',
  '单元管理员':'Unit Admin',
  '获取用户数据失败，请点击左上角刷新按钮':'Get user data failed, click refresh',

  '软件版本':'Software Version',

  '获取限制设备信息失败':'Get limit device info failed',

  '个设备设置成功':' device set OK',

  // ==================== data.vue 页面 ====================
  '昨日用能':'Yesterday Energy',
  '设备数据':'Device Data',
  '昨日能耗排名':'Yesterday Energy Ranking',
  '排名等级':'Rank',
  '日耗能量':'Daily Energy',
  '用电趋势':'Power Trend',
  '当月能耗分析':'Monthly Energy Analysis',
  '当月能耗排名':'Monthly Energy Ranking',
  '电量(kWh)':'Energy(kWh)',
  '时长(时)':'Duration(H)',
  '电费(元)':'Cost(¥)',
  '在线数据:':'Online Data:',
  '在线数据：':'Online Data:',
  '离线':'Offline',
  '在线':'Online',
  '台':'dev(s)',
  '离线设备':'Offline Devices',
  '开关数据:':'Switch Data:',
  '开关数据：':'Switch Data:',
  '关机':'OFF',
  '开机':'ON',
  '开机设备':'ON Devices',
  '关机设备':'OFF Devices',
  '故障数据:':'Fault Data:',
  '故障':'Fault',
  '正常':'Normal',
  '故障设备':'Fault Devices',
  '电费':'Cost',
  '元':'¥',
  '号':'No.',
  '设备信息':'Device Info',
  '区域筛选':'Area Filter',
  '网关qid':'GW QID',
  '故障码':'Fault Code',
  '获取报表数据失败，请点击左上角刷新按钮':'Get report data failed, click refresh',
  '报表数据':'Report Data',

  '内容':'Content',
  '限制状态':'Limit Status',
  '解除限制':'Remove Limit',
  '解除限制+解锁':'Remove Limit + Unlock',
  '未限制':'Unlimited',
  '您确定要将选中设备全部限制吗？限制后设备将锁定不可控制.':'Are you sure to limit all selected devices? Devices will be locked and uncontrollable.',
  '您确定要将选中设备全部解除限制吗？解除后设备恢复可控制.':'Are you sure to remove limits on all selected devices? Devices will be restored to controllable.',
  '您确定要将选中设备全部解除限制并解锁吗？解除后设备恢复可控制.':'Are you sure to remove limits and unlock all selected devices? Devices will be restored to controllable.',
  '请先勾选设备':'Please select devices first',
  '修改单价失败':'Modify price failed',

  // ==================== home.vue 菜单 ====================
  '展示页面':'Display',
  '区域总览':'Area View',
  '数据总览':'Data View',
  '设备控制':'Dev Ctrl',
  '空调内机':'AC Indoor',
  '空调主机':'AC Main',
  '灯控面板':'Light',
  '通断模块':'Switch',
  '电脑':'PC',
  '变送器':'Xmitter',
  '传感器':'Sensor',
  '批量控制':'Batch',
  '设备组控':'Group',
  '场景联动':'Scene',
  '场景控制':'Scene Ctrl',
  '定时控制':'Timer',
  '联动控制':'Link',
  '课程表配置':'Schedule Cfg',
  '课程表显示':'Schedule',
  '配置管理':'Config',
  '设备管理':'Dev Mgmt',
  '网关管理':'GW Mgmt',
  '电表管理':'Meter Mgmt',
  '水表关联':'Water Link',
  '区域管理':'Area Mgmt',
  '计费管理':'Billing',
  '公司计费':'Co. Billing',
  '计费电价':'Price',
  '计费系数':'Factor',
  '充值记录':'Recharge',
  '系统限制':'Sys Limit',
  '平台限制':'Platform',
  '欠费停机':'Arrears',
  '数据查询':'Query',
  '设备状态':'Status',
  '网关记录':'GW Log',
  '温度记录':'Temp Log',
  '控制记录':'Ctrl Log',
  '电表数据':'Meter Data',
  '电量报表':'Power Rpt',
  '分段计费报表':'Seg Rpt',
  '水机配置':'Chiller',
  '温度限制':'Temp Limit',
  '面板加密':'Panel Lock',
  '菜单锁定':'Menu Lock',
  '水机校时':'Chiller Time',
  '水机定时':'Chiller Timer',
  '水机点位':'Chiller Pt',
  '红外巡检':'IR Patrol',
  '单寄存器':'Register',
  '用户管理':'User Mgmt',
  '电表':'Meter',
  '修改密码':'Chg Pwd',
  '修改名称':'Chg Name',
  '上传图片':'Upload Img',
  '上传位置':'Upload Loc',
  '退出登录':'Logout',
  '切换区域':'Switch Area',
  '系统设置':'Settings',
  '进入此区域':'Enter',
  '楼栋信息':'Bldg Info',
  '单元信息':'Unit Info',
  '楼栋管理':'Bldg Mgmt',
  '单元管理':'Unit Mgmt',
  '楼栋位置':'Bldg Loc',
  '区域名称':'Area Name',
  '区域备注':'Area Note',
  '添加区域':'Add Area',
  '楼栋备注':'Bldg Note',
  '添加楼栋':'Add Bldg',
  '单元名称':'Unit Name',
  '单元备注':'Unit Note',
  '添加单元':'Add Unit',
  '所属楼栋':'Bldg',
  '关联图片':'Image',

  // ==================== Element UI 默认文本 ====================
  '取 消':'Cancel',
  '确 定':'Confirm',

  // ==================== sj 页面 ====================
  '区域筛选：':'Area Filter:',
  '选择小区':'Select Area',
  '选择楼栋':'Select Bldg',
  '选择单元':'Select Unit',
  '查询时段：':'Query Period:',
  '查询时间':'Query Time',
  '结果筛选：':'Result Filter:',
  '反查询结果':'Reverse Query',
  '一键设置':'Set All',
  '一键读取':'Get All',
  '设置':'Set',
  '读取':'Get',
  '本地定时':'Local Timer',
  '说明：时设置为24不执行，第一次设置要先把开关设置为开启':'Note: Set hour to 24 to disable. Turn switch ON first.',
  '批量设置':'Batch Set',
  '开启':'ON',
  '关闭':'OFF',
  '星期选择':'Weekday',
  '星期选择 :':'Weekday :',
  '全选':'All',
  '开机(时)':'ON(H)',
  '开机(分)':'ON(M)',
  '关机(时)':'OFF(H)',
  '关机(分)':'OFF(M)',
  '时间校准':'Time Sync',
  '关闭自动校时':'Auto Sync Off',
  '广播校时':'Broadcast',
  '逐个校时':'One by One',
  '单寄存器控制':'Register Ctrl',
  '设备地址：':'Dev Addr:',
  '寄存器地址：':'Reg Addr:',
  '设置值：':'Set Val:',
  '控制':'Ctrl',
  '发送':'Send',
  '菜单密码：':'Menu Pwd:',
  '加密密码：':'Lock Pwd:',
  '温度锁定':'Temp Lock',
  '制冷温度：':'Cool Temp:',
  '制热温度：':'Heat Temp:',
  '最低':'Min',
  '最高':'Max',
  '巡检功能':'Patrol',
  '关闭巡检':'Patrol Off',
  '开启巡检':'Patrol On',
  '网关编号':'GW No.',
  '您确定要删除此网关吗？':'Delete this GW?',
  '所属楼层':'Floor',
  '所属房间':'Room',
  '所属网关':'GW',
  '设备ID':'Dev ID',
  '查询结果':'Result',
  '定时总开关':'Timer Pwr',
  '周期时段1':'Cycle1',
  '开机时段1':'ON1',
  '关机时段1':'OFF1',
  '周期时段2':'Cycle2',
  '开机时段2':'ON2',
  '关机时段2':'OFF2',
  '周期时段3':'Cycle3',
  '开机时段3':'ON3',
  '关机时段3':'OFF3',
  '周期时段4':'Cycle4',
  '开机时段4':'ON4',
  '关机时段4':'OFF4',
  '小区':'Area',
  '楼栋':'Bldg',
  '单元':'Unit',
  '楼层':'Floor',
  '房间':'Room',
  '请先勾选在线设备':'Select online dev first',
  '部分网关控制失败':'Some GW ctrl failed',
  '控制成功':'Ctrl OK',
  '控制失败':'Ctrl Fail',
  '获取网关数据失败，请点击左上角刷新按钮':'Get GW data failed, click refresh',
  '获取设备数据失败，请点击左上角刷新按钮':'Get dev data failed, click refresh',
  '获取本地定时失败':'Get local timer failed',
  '拿到本地定时':'Got local timer',
  '获取校时数据失败':'Get time sync failed',
  '拿到水机时间':'Got chiller time',
  '获取寄存器值失败':'Get register failed',
  '拿到寄存器地址值':'Got register val',
  '获取寄存器地址值失败':'Get register val failed',
  '获取菜单密码失败':'Get menu pwd failed',
  '拿到菜单密码':'Got menu pwd',
  '获取面板加密失败':'Get panel lock failed',
  '拿到面板密码':'Got panel pwd',
  '获取温度上下限失败':'Get temp limit failed',
  '拿到温度上下限':'Got temp limit',
  '获取巡检数据失败':'Get patrol data failed',
  '拿到巡检状态':'Got patrol status',
  '请先输入对应值':'Enter values first',
  '请先输入查询地址':'Enter query addr first',
  '请先选择楼层':'Select floor first',
  '正在发送中...':'Sending...',
  '正在获取中...':'Getting...',
  '一':'Mon',
  '二':'Tue',
  '三':'Wed',
  '四':'Thu',
  '五':'Fri',
  '六':'Sat',

  '周一、':'Mon,',
  '周二、':'Tue,',
  '周三、':'Wed,',
  '周四、':'Thu,',
  '周五、':'Fri,',
  '周六、':'Sat,',
  '周日、':'Sun,',
  '第1时段：':'Period1:',
  '第2时段：':'Period2:',
  '第3时段：':'Period3:',
  '第4时段：':'Period4:',
  '寄存器：':'Register:',
  '寄存器地址':'Reg Addr',
  '设置值':'Set Val',
  '发 送':'Send',
  '读 取':'Read',
  '时':'H',
  '分':'M',
  '1月':'Jan',
  '2月':'Feb',
  '3月':'Mar',
  '4月':'Apr',
  '5月':'May',
  '6月':'Jun',
  '7月':'Jul',
  '8月':'Aug',
  '9月':'Sep',
  '10月':'Oct',
  '11月':'Nov',
  '12月':'Dec',

  // ==================== dlSumLog1.vue 页面 ====================
  '电量详情':'Power Details',
  '月报表':'Monthly Report',
  '公司筛选：':'Company Filter:',
  '开始日期':'Start Date',
  '结束日期':'End Date',
  '至':'To',
  '总计(高时)':'Total(High)',
  '总计(中时)':'Total(Mid)',
  '总计(低时)':'Total(Low)',
  '总计(时长)':'Total(Duration)',
  '总计(电费)':'Total(Cost)',
  '时长(高)':'Duration(High)',
  '时长(中)':'Duration(Mid)',
  '时长(低)':'Duration(Low)',
  '总计':'Total',
  '报表':'Report',
  '单项报表':'Single Report',
  '水机报表':'Chiller Report',
  '时长':'Duration',
  '总计(度)':'Total(kWh)',
  '总计(元)':'Total(¥)',
  '总计(时)':'Total(H)',
  '获取设备名称数据失败，请点击左上角刷新按钮':'Get dev name data failed, click refresh',

  // ==================== dlTabDay.vue / dlTabMoon.vue 电量报表页面 ====================
  '日报表':'Daily Report',
  '展示筛选':'Show Filter',
  '报表展示内容':'Report Display Content',
  '日总时长':'Total Daily Duration',
  '日总电量':'Total Daily Energy',
  '日总电费':'Total Daily Cost',
  '高时长':'High Duration',
  '中时长':'Medium Duration',
  '低时长':'Low Duration',
  '时长 (时)':'Duration (H)',
  '电量 (度)':'Energy (kWh)',
  '电费 (元)':'Cost (¥)',
  '公司':'Company',
  '保存报表筛选数据失败':'Failed to save report filter data',
  '获取报表筛选失败':'Failed to get report filter',
  '日时长 (时)':'Daily Duration (H)',
  '日电量 (度)':'Daily Energy (kWh)',
  '日电费 (元)':'Daily Cost (¥)',
  '高风 (时)':'High Fan (H)',
  '中风 (时)':'Mid Fan (H)',
  '低风 (时)':'Low Fan (H)',
  '拿到场景信息':'Got scene info',
  '获取场景数据失败，请点击左上角刷新按钮':'Get scene data failed, click refresh',
  '获取联动数据失败，请点击左上角刷新按钮':'Get link data failed, click refresh',
  '获取设备参数失败，请点击左上角刷新按钮':'Get device param failed, click refresh',
  '拿到单元信息':'Got unit info',
  '拿到楼层信息':'Got floor info',
  '拿到房间信息':'Got room info',
  '拿到月报表数据':'Got monthly report data',
  '拿到公司信息':'Got company info',
  '拿到电量报表信息失败':'Failed to get power report info',
  '获取区域信息失败':'Get area info failed',
  '拿到区域信息':'Got area info',
  '拿到报表数据':'Got report data',

  // ==================== dataLogDb.vue 页面 ====================
  '日数据':'Daily Data',
  '月数据':'Monthly Data',
  '电表名称':'Meter Name',
  '电表MAC':'Meter MAC',
  '查询电能':'Query Energy',
  '累计电量(度)':'Cumulative Energy(kWh)',

  // ==================== dataLogDbMoon.vue 页面 ====================
  '总计(电量)':'Total(Energy)',
  '度':'kWh',
  '最小':'Min',
  '最大':'Max',

  // ==================== scene 页面 ====================
  '搜索联动名称':'Search Link',
  '新增联动':'Add Link',
  '所属区域：':'Area:',
  '修改':'Edit',
  '保存信息':'Save Info',
  '删除联动':'Del Link',
  '执行时间':'Exec Time',
  '日期选择：':'Date:',
  '周期选择':'Cycle',
  '周期选择 :':'Cycle :',
  '执行时间段：':'Exec Period:',
  '起始时间':'Start Time',
  '结束时间':'End Time',
  '触发设备':'Trigger',
  '筛选设备名称':'Filter Dev',
  '新增动作':'Add Action',
  '满足条件':'Condition',
  '触发动作':'Trigger',
  '执行场景':'Exec Scene',
  '筛选执行内容':'Filter Content',
  '新增场景':'Add Scene',
  '新增延时':'Add Delay',
  '执行类型':'Exec Type',
  '执行内容':'Exec Content',
  '联动名称：':'Link Name:',
  '新增条件':'Add Condition',
  '设备列表':'Dev List',
  '选中列表':'Selected',
  '设备类型：':'Dev Type:',
  '条件选项：':'Condition:',
  '状态':'Status',
  '开关1':'Switch 1',
  '开关2':'Switch 2',
  '开关3':'Switch 3',
  '开关4':'Switch 4',
  '值':'Val',
  '修改条件':'Edit Condition',
  '场景内容':'Scene Content',
  '场景名称：':'Scene Name:',
  '延时内容':'Delay Content',
  '选择时间':'Select Time',
  '所属楼栋：':'Bldg:',
  '所属楼层：':'Floor:',
  '所属房间：':'Room:',
  '您确定要删除此联动吗？':'Delete this link?',
  '并且':'AND',
  '或者':'OR',
  '周期执行':'Cycle Exec',
  '时间执行':'Time Exec',
  '条件满足时执行一次':'Exec Once',
  '条件满足时5分钟检测一次':'Check 5min',
  '当':'When',
  '保存成功':'Saved',
  '保存失败':'Save Fail',
  '添加场景':'Add Scene',
  '场景名称':'Scene Name',
  '场景描述':'Scene Desc',
  '场景描述：':'Scene Desc:',
  '请输入场景描述':'Enter scene desc',
  '筛选内容：':'Filter:',
  '请输入设备名称筛选':'Filter dev name',
  '添加执行内容':'Add Action',
  '场景详情':'Scene Detail',
  '修改场景':'Edit Scene',
  '修改场景信息':'Edit Scene Info',
  '场景选项：':'Scene Option:',
  '开关：':'Pwr:',
  '模式：':'Mode:',
  '课程表：':'Schedule:',
  '锁定：':'Lock:',
  '温度：':'Temp:',
  '风速：':'Fan:',
  '停机：':'Stop:',
  '校时：':'Sync:',
  '限制：':'Limit:',
  '开关控制':'Pwr Ctrl',
  '模式控制':'Mode Ctrl',
  '锁定控制':'Lock Ctrl',
  '组合控制':'Multi Ctrl',
  '校时控制':'Sync Ctrl',
  '停机控制':'Stop Ctrl',
  '课程表控制':'Schedule Ctrl',
  '风盘制热':'Fan Heat',
  '地暖制热':'Floor Heat',
  '同时制热':'Both Heat',
  '制冷':'Cool',
  '送风':'Fan',
  '同步':'Sync',
  '解锁':'Unlock',
  '锁定':'Lock',
  '全锁':'Full Lock',
  '半锁':'Half Lock',
  '不锁':'No Lock',
  '制热':'Heat',
  '除湿':'Dehum',
  '低风':'Low',
  '中风':'Mid',
  '高风':'High',
  '自动':'Auto',
  '模式':'Mode',
  '风速':'Fan Spd',
  '锁定温度':'Lock Temp',
  '解除':'Release',
  '限制':'Limit',
  '解停':'Resume',
  '停机':'Stop',
  '广播':'Broadcast',
  '逐个':'One by One',
  '关闭课程表':'Schedule Off',
  '开启课程表':'Schedule On',
  '同步课程表':'Schedule Sync',
  '功能控制':'Func Ctrl',
  '添加定时':'Add Timer',
  '定时名称':'Timer Name',
  '定时开关：':'Timer Pwr:',
  '定时名称：':'Timer Name:',
  '日期类型：':'Date Type:',
  '周期控制':'Cycle Ctrl',
  '日期控制':'Date Ctrl',
  '定时选项：':'Timer Opt:',
  '选择场景':'Select Scene',
  '选择日期':'Select Date',
  '时间选择':'Time Select',
  '时间选择 :':'Time Select :',
  '场景：':'Scene:',
  '日期 :':'Date :',
  '关联区域':'Link Area',
  '关联':'Link',
  '开关':'Pwr',
  '日期':'Date',
  '时间':'Time',
  '控制类型':'Ctrl Type',
  '执行操作':'Exec Action',
  '区域':'Area',
  '添加定时失败':'Add timer failed',
  '修改定时信息失败':'Change timer failed',
  '删除定时失败':'Del timer failed',
  '您确定要删除此定时吗？':'Delete this timer?',
  '请先选择星期和时间':'Select weekday & time',
  '请先选择执行场景':'Select scene first',
  '请先选择所属房间':'Select room first',
  '关联成功':'Linked',
  '关联区域失败':'Link area failed',
  '发送成功':'Sent',
  '执行失败':'Exec failed',
  '执行':'Exec',
  '执行中':'Running',
  '请先设置场景名称':'Set scene name first',
  '请先设置场景内容':'Set scene content first',
  '请先选择设备':'Select dev first',
  '状态筛选：':'Status Filter:',
  '锁定状态':'Lock Status',
  '课程状态':'Schedule Status',
  '课程':'Class',
  '有课':'Class',
  '无课':'No Class',
  '未锁':'Unlocked',
  '控制失败查看':'Fail View',
  '控制功能':'Ctrl Func',
  '控制功能：':'Ctrl Func:',
  '锁定功能':'Lock Func',
  '批量解锁':'Batch Unlock',
  '批量锁定':'Batch Lock',
  '下发失败数据':'Fail Data',
  '失败信息':'Fail Info',
  '楼栋映射表':'Bldg Map',
  '平台名称':'Platform',
  '课程表名':'Table Name',
  '时间设置':'Time Set',
  '选择周期':'Select Cycle',
  '选择星期':'Select Week',
  '课节数':'Joint No.',
  '星期一':'Monday',
  '星期二':'Tuesday',
  '星期三':'Wednesday',
  '星期四':'Thursday',
  '星期五':'Friday',
  '星期六':'Saturday',
  '星期日':'Sunday',
  '周期':'Cycle',
  '星期':'Week',
  '节数':'Joint',
  '设备个数':'Dev Count',
  '第':'No.',
  '周':'Wk',
  '开学日期：':'Start Date:',
  '功能开关：':'Func Pwr:',
  '提前开启：':'Early Open:',
  '提前多久开启':'How early',
  '操作设置：':'Op Set:',
  '当前学期：':'Term:',
  '1学期':'Term 1',
  '2学期':'Term 2',
  '限制设备：':'Limit Dev:',
  '1学期时间表：':'Term 1:',
  '2学期时间表：':'Term 2:',
  '上课时间':'Class Start',
  '下课时间':'Class End',
  '第节':'Joint',
  '温度':'Temp',
  '数字':'Num',
  '请先选择开学日期和提前开启时间':'Select start date & early time',
  '请先选择学期和时间表':'Select term & timetable',
  '获取课程时间失败':'Get schedule time failed',
  '获取课程表失败':'Get schedule failed',
  '获取楼栋映射名失败':'Get bldg map failed',
  '获取设备失败':'Get dev failed',
  '无设置失败定时':'No failed timer',
  '批量设置定时中，请稍后...':'Batch setting timer...',
  '设备离线':'Dev Offline',
  '第个设备设置成功':'th device set OK',
  '在线状态':'Online Status',
  '开关状态':'Pwr Status',
  '制冷温度:':'Cool:',
  '，制热温度:':', Heat:',
  '密码:':'Pwd:',
  '档':'Gear',
  '地暖':'Floor Heat',
  '分组名称':'Group Name',
  '分组名称：':'Group Name:',
  '分组内容':'Group Content',
  '状态关联':'Status Link',
  '状态关联：':'Status Link:',
  '添加分组':'Add Group',

  '组合':'Combo',

  // ==================== diaRentTiming.vue 弹窗 ====================
  '定时开关:':'Timer Pwr:',
  '开':'On',
  '关':'Off',
  '执行时间:':'Exec Time:',
  '周期:':'Cycle:',
  '周一':'Mon',
  '周二':'Tue',
  '周三':'Wed',
  '周四':'Thu',
  '周五':'Fri',
  '周六':'Sat',
  '周日':'Sun',
  '节假日':'Holiday',
  '定时选项:':'Timer Opt:',
  '温度范围:':'Temp Range:',
  '编辑定时':'Edit Timer',
  '请选择执行时间':'Select exec time',
  '请至少选择一个周期':'Select at least one cycle',
  '添加定时成功':'Add timer success',
  '添加失败':'Add fail',
  '修改定时成功':'Edit timer success',
  '修改定时失败':'Edit timer fail',
  '请输入备注':'Enter note',

  // ==================== dlRentTiming.vue 页面 ====================
  '返回':'Back',
  '定时列表':'Timer List',
  '租户定时列表':'Tenant Timer List',
  '定时开关':'Timer Switch',
  '定时选项':'Timer Option',
  '缺少租户ID参数':'Missing tenant ID parameter',
  '获取数据失败':'Get data failed',
  '同一个租户最多可添加 6 组定时':'A tenant can add up to 6 timers',
  '确认删除该定时任务？此操作不可恢复！':'Confirm delete this timer? This cannot be undone!',
  '定时已开启':'Timer enabled',
  '定时已关闭':'Timer disabled',

  // ==================== daiPriceForm.vue 弹窗 ====================
  '配置名称':'Config Name',
  '请输入配置名称':'Enter config name',
  '固定电价':'Fixed Price',
  '元/kWh':'CNY/kWh',
  '填写固定电价后，分时时段将不可用':'Time-of-use slots will be unavailable after fixed price is set',
  '分时电价配置':'Time-of-Use Price Config',
  '（只支持整点，0-24时，需按顺序填写，设为24:00后下方时段自动截止）':'(Hourly only, 0-24h, fill in order; setting 24:00 auto-closes below slots)',
  '时段':'Slot',
  '开始时间':'Start Time',
  '选择':'Select',
  '电价':'Price',
  '已启用固定电价模式，分时电价配置已禁用':'Fixed price mode enabled, time-of-use config disabled',
  '固定电价模式下，时段电价必须为空':'Slots must be empty in fixed price mode',
  '请至少填写一个时段':'Please fill at least one slot',
  '的开始时间必须小于':' start time must be less than ',
  '新增配置':'Add Config',

  // ==================== diaKtCtr.vue 弹窗 ====================
  '空调控制器':'AC Controller',
  '设定':'Set',
  '室内':'Indoor',
  '阀开':'Valve Open',
  '阀关':'Valve Close',
  '模式选择':'Mode Select',
  '锁定设置':'Lock Set',
  '风速调节':'Fan Adj',

  '获取设备日志失败，请点击左上角刷新按钮':'Get dev log failed, click refresh',

  // ==================== diaLogDev.vue 弹窗 ====================
  '历史':'History',
  '操作类型':'Op Type',
  '序号':'No.',
  '操作时间':'Op Time',
  '操作来源':'Op Source',
  '操作内容':'Op Content',
  '操作结果':'Op Result',
  '获取控制日志失败，请稍后重试':'Get log failed, retry later',
  '获取设备列表失败':'Get dev list failed',

  // ==================== diaLogDev.vue 日志内容翻译 ====================
  '设备上报':'Dev Report',
  '环境温度':'Env Temp',
  '初始':'Init',
  '低速':'Low Spd',
  '中速':'Mid Spd',
  '高速':'High Spd',
  '1档':'1Gear',
  '2档':'2Gear',
  '3档':'3Gear',
  '设定温度':'Set Temp',
  '水阀':'Water Valve',
  '通风':'Ventilation',
  '灯1':'Light1',
  '灯2':'Light2',
  '灯3':'Light3',
  '灯4':'Light4',
  '开灯':'Light On',
  '关灯':'Light Off',
  '限制控制':'Limit Ctrl',
  '锁定、':'Lock,',
  '解锁 ':'Unlock ',
  '开机 ':'ON ',
  '关机 ':'OFF ',
  '制热 ':'Heat ',
  '制冷 ':'Cool ',
  '送风 ':'Fan ',
  '除湿 ':'Dehum ',
  '低风 ':'Low ',
  '中风 ':'Mid ',
  '高风 ':'High ',
  '自动 ':'Auto ',
  '通风 ':'Ventilation ',
  '限制 - ':'Limit - ',
  '解除 ':'Release ',
  '停机 ':'Stop ',
  '解停 ':'Resume ',
  '关闭 ':'Close ',
  '同步 ':'Sync ',
  '开启 ':'ON ',

  '修改区域信息失败':'Change area info failed',
  '您确定要删除此区域吗？':'Are you sure you want to delete this area?',
  '修改区域结构':'Modify Area Structure',
  '最大区域：':'Max Area:',
  '请输入名称':'Enter name',
  '添加子分组':'Add Sub Group',
  '修改分组':'Edit Group',
  '删除分组':'Delete Group',
  '全部区域':'All Areas',
  '新增区域':'Add Area',
  '全部小区':'All Areas',
  '新增小区':'Add Area',
  '全部楼栋':'All Bldgs',
  '新增楼栋':'Add Bldg',
  '全部单元':'All Units',
  '新增单元':'Add Unit',
  '全部楼层':'All Floors',
  '新增楼层':'Add Floor',
  '添加小区':'Add Area',
  '小区名称：':'Area Name:',
  '楼栋名称：':'Bldg Name:',
  '单元名称：':'Unit Name:',
  '楼层名称：':'Floor Name:',
  '添加房间':'Add Room',
  '房间名称：':'Room Name:',
  '修改小区':'Edit Area',
  '修改楼栋':'Edit Bldg',
  '修改单元':'Edit Unit',
  '修改楼层':'Edit Floor',
  '修改房间':'Edit Room',
  '请先选择楼栋':'Select bldg first',
  '拿到区域信息失败':'Get area info failed',
  '拿到楼栋信息':'Got building info',

  // ==================== dlSjXs.vue 页面 ====================
  '计费方式：':'Billing Mode:',
  '盘管系数：':'Fan Arg:',
  '高制冷量：':'High Cool:',
  '高档占比：':'High Ratio:',
  '中制冷量：':'Mid Cool:',
  '中档占比：':'Mid Ratio:',
  '低制冷量：':'Low Cool:',
  '低档占比：':'Low Ratio:',
  '风机耗电：':'Fan Power:',
  '导入数据':'Import Data',
  '计费信息':'Billing Info',
  '盘管系数':'Fan Arg',
  '高制冷量':'High Cool',
  '高档占比':'High Ratio',
  '中制冷量':'Mid Cool',
  '中档占比':'Mid Ratio',
  '低制冷量':'Low Cool',
  '低档占比':'Low Ratio',
  '风机耗电':'Fan Power',
  '导入水机系数 (批量修改)':'Import Chiller Factor (Batch)',
  '水机系数':'Chiller Factor',
  '获取水机系数失败，请点击左上角刷新按钮':'Get chiller factor failed, click refresh',
  '不计费':'No Billing',
  '时长计费':'Time Billing',
  '能耗计费':'Energy Billing',
  '电表计费':'Meter Billing',
  '获取水机系数失败':'Get chiller factor failed',
  '修改水机系数失败':'Change chiller factor failed',
  '只能上传.xlsx、.xls、.csv 文件!':'Only .xlsx, .xls, .csv files allowed!',
  '设备类型':'Dev Type',
  '计费方式':'Billing Mode',
  '高档系数':'High Factor',
  '中档系数':'Mid Factor',
  '低档系数':'Low Factor',

  // ==================== aShow.vue ====================
  '当月能耗':'Monthly Energy',
  '进入区域':'Enter Area',
  '故障状态':'Fault Status',
  '操作说明':'Operation Description',
  '总充值：':'Total Recharge:',
  '总扣费：':'Total Deduction:',
  '临时余额':'Temp Balance',
  '发票':'Invoice',
  '扣费':'Deduction',
  '上线':'Online',
  '操作人员':'Operator',
  '变动金额':'Change Amount',
  '收 款 单':'Receipt',
  '缴费时间：':'Payment Time:',
  '公司：':'Company:',
  '操作内容：':'Op Content:',
  '剩余金额：':'Remaining Amount:',
  '收款人：':'Payee:',
  '审核人：':'Reviewer:',
  '客户：':'Customer:',
  '电量记录':'Power Record',

  // ==================== dataLogCz.vue 页面 ====================
  '（临时余额）':'(Temp Balance)',
  '拿到充值信息':'Got recharge info',
  '获取充值数据失败，请点击左上角刷新按钮':'Get recharge data failed, click refresh',

  // ==================== dataNew.vue 页面 ====================
  '设备状态：':'Status:',
  '在线:':'Online:',
  '离线:':'Offline:',
  '模式状态':'Mode Status',
  '风速状态':'Fan Status',
  '室内温度':'Indoor Temp',
  '水阀状态':'Valve Status',
  '上线时间':'Online Time',
  '运行时间':'Run Time',
  '拔卡':'Card Out',
  '插卡':'Card In',
  '获取设备数据失败':'Get dev data failed',
  '获取停机设备信息失败':'Get stop dev info failed',
  '停机状态':'Stop Status',
  '未停':'Not Stopped',
  '您确定要将选中设备全部停机吗？停机后设备将锁定不可控制.':'Stop all selected devices? They will be locked after stopping.',
  '您确定要将选中设备全部解除停机吗？解除后设备恢复可控制.':'Resume all selected devices? They will be controllable after resuming.',
  '控制设备报错':'Ctrl device error',
  '电价不能为空':'Price cannot be empty',
  '起始时间不能为空':'Start time cannot be empty',
  '结束时间不能为空':'End time cannot be empty',
  '元/度':'CNY/kWh',
  '元/小时':'CNY/hour',
  '电价信息':'Price Info',
  '电价：':'Price:',
  '起始时间：':'Start Time:',
  '电价设置':'Price Setting',
  '时段计费配置':'Time Billing Config',
  '节假日计费配置':'Holiday Billing Config',

  // ==================== dlDjSon.vue 页面 ====================
  '计费选择：':'Billing Selection:',
  '时段1：':'Period1:',
  '时段2：':'Period2:',
  '时段3：':'Period3:',
  '单价：':'Unit Price:',
  '时段1电价不能为空':'Period1 price cannot be empty',
  '时段1起始时间不能为空':'Period1 start time cannot be empty',
  '时段1结束时间不能为空':'Period1 end time cannot be empty',
  '时段2电价不能为空':'Period2 price cannot be empty',
  '时段2起始时间不能为空':'Period2 start time cannot be empty',
  '时段2结束时间不能为空':'Period2 end time cannot be empty',
  '时段3电价不能为空':'Period3 price cannot be empty',
  '时段3起始时间不能为空':'Period3 start time cannot be empty',
  '时段3结束时间不能为空':'Period3 end time cannot be empty',

  // ==================== dlSumTab.vue 页面 ====================
  '时长总计(时)':'Total Duration(H)',
  '电量总计(度)':'Total Energy(kWh)',
  '电费总计(元)':'Total Cost(¥)',

  // ==================== dlDjSon1.vue 页面（补充 dlDjSon.vue 中已有的） ====================
  '区分节假日：':'Distinguish Holidays:',
  '开启后到日期自动更改计费时段和单价':'Auto-change billing period and price after date',
  '计费时段：':'Billing Period:',
  '获取时段计费失败':'Get time billing failed',

  // ==================== dlTabMoon.vue 页面 ====================
  '总计(高时长)':'Total(High Duration)',
  '总计(中时长)':'Total(Mid Duration)',
  '总计(低时长)':'Total(Low Duration)',
  '总计(时段1)':'Total(Period1)',
  '总计(时段2)':'Total(Period2)',
  '总计(时段3)':'Total(Period3)',
  '总时段1时长 (时)':'Total Period1 Duration (H)',
  '总时段1电量 (度)':'Total Period1 Energy (kWh)',
  '总时段1电费 (元)':'Total Period1 Cost (¥)',
  '总时段2时长 (时)':'Total Period2 Duration (H)',
  '总时段2电量 (度)':'Total Period2 Energy (kWh)',
  '总时段2电费 (元)':'Total Period2 Cost (¥)',
  '总时段3时长 (时)':'Total Period3 Duration (H)',
  '总时段3电量 (度)':'Total Period3 Energy (kWh)',
  '总时段3电费 (元)':'Total Period3 Cost (¥)',
  '时段1时间':'Period1 Time',
  '时段1时长 (时)':'Period1 Duration (H)',
  '时段1电量 (度)':'Period1 Energy (kWh)',
  '时段1电费 (元)':'Period1 Cost (¥)',
  '时段2时间':'Period2 Time',
  '时段2时长':'Period2 Duration',
  '时段2电量':'Period2 Energy',
  '时段2电费':'Period2 Cost',
  '时段3时间':'Period3 Time',
  '时段3时长':'Period3 Duration',
  '时段3电量':'Period3 Energy',
  '时段3电费':'Period3 Cost',

  // ==================== glFmlCeng.vue 页面 ====================
  '房间信息':'Room Info',
  '请输入房间名称':'Enter room name',
  '您确定要删除此房间吗？':'Delete this room?',
  '添加房间失败':'Add room failed',
  '修改房间信息失败':'Change room info failed',
  '删除房间失败':'Del room failed',

  // ==================== glDvcFind.vue 页面 ====================
  '搜索设备':'Search Device',
  '一键添加':'One-Click Add',
  '设备名称：':'Dev Name:',
  '请输入栋层名称':'Enter bldg/floor name',
  '所属网关：':'GW:',
  '设备ID：':'Dev ID:',
  '最小值':'Min',
  '最大值':'Max',
  '您确定要删除此设备吗？':'Are you sure to delete this device?',
  '请先选择所属网关':'Select GW first',
  '请先选择所属楼栋':'Select bldg first',
  '请先选择所属楼层':'Select floor first',
  '请先输入设备名称':'Enter dev name first',
  '请先输入空调内机编号':'Enter AC indoor unit No. first',
  '添加设备失败':'Add device failed',
  '修改设备信息失败':'Change device info failed',
  '删除设备失败':'Delete device failed',

  // ==================== glDbWat.vue 页面 ====================
  '添加关联':'Add Water Link',
  '水表关联内容':'Water Meter Link',
  '水表MAC':'Water Meter MAC',
  '总表MAC':'Total Meter MAC',
  '水表占比':'Water Meter Ratio',
  '您确定要删除此关联吗？':'Are you sure you want to delete this link?',
  '待选列表':'Pending List',
  '分摊':'Apportion',
  '不分摊':'No Apportion',
  '645协议':'645 Protocol',
  '占比':'Ratio',
  '实时电能':'Real-time Energy',
  '发送数据中...':'Sending data...',
  '查询成功':'Query successful',
  '查询电能失败':'Query energy failed',
  '删除电表失败':'Delete meter failed',
  '请先输入分摊占比':'Please enter apportionment ratio first',
  '请先选择水表MAC':'Please select water meter MAC first',
  '请先选择总表MAC':'Please select total meter MAC first',
  '修改电表失败':'Modify meter failed',
  '获取网关协议失败，请点击左上角刷新按钮':'Get gateway protocol failed, click refresh',
  '获取电表数据失败':'Get meter data failed',
  '添加电表失败':'Add meter failed',

  // ==================== glDvc.vue 页面 ====================
  '获取设备类型数据失败':'Get device type data failed',
  '添加楼栋失败':'Add building failed',
  '请先添加区域、网关':'Add area and GW first',
  '批量添加一次最大30个':'Batch add max 30 at once',
  '请先选择设备类型':'Select device type first',
  '请先选择区域':'Select area first',
  '请先勾选要添加的设备ID':'Select device IDs to add first',
  '全部添加':'Add All',
  '在线添加':'Add Online',
  '导入设备':'Import Device',
  '导入网关':'Import GW',
  '导入单元':'Import Unit',
  '导入楼层':'Import Floor',
  '导入房间':'Import Room',
  '状态筛选':'Status Filter',
  '网关搜索添加设备':'Search & Add Device via GW',
  '搜索添加':'Search Add',
  '批量添加':'Batch Add',
  '添加设备':'Add Device',
  '设备信息.xlsx':'Device Info.xlsx',

  // ==================== glDb.vue 页面 ====================
  '设备筛选':'Device Filter',
  '多联MAC':'Multi-Link MAC',
  '电表配置':'Meter Config',
  '添加电表':'Add Meter',
  '查询数据':'Query Data',
  '查电量':'Query Energy',
  '查功率':'Query Power',
  '电表内容':'Meter Content',
  '电表协议':'Meter Protocol',
  '电表地址':'Meter Address',
  '电表变比':'Meter Ratio',
  '波特率':'Baud Rate',
  '校验位':'Parity',
  '待机分摊':'Standby Share',
  '电表备注':'Meter Note',
  '外机日耗电':'Outdoor Daily Power',
  '您确定要删除此电表吗？':'Are you sure to delete this meter?',
  '导入设备 (按顺序 网关-电表)':'Import Device (GW-Meter in order)',
  '导入电表':'Import Meter',
  '变比':'Ratio',
  '通讯协议':'Protocol',
  '功率(kW)':'Power(kW)',
  '最新时间':'Latest Time',
  '累计电能':'Cumulative Energy',
  '查询功率失败':'Query power failed',
  '配置发送成功':'Config sent OK',
  '配置电表数据报错':'Config meter error',
  '请先输入电表名称':'Enter meter name first',
  '请先输入电表地址':'Enter meter address first',
  '请先选择通讯协议':'Select protocol first',
  '℃':'℃',
  '获取课程表执行信息失败':'Get schedule exec info failed',
  '网关mac':'GW MAC',
  '电量1':'Energy1',
  '电费1':'Cost1',
  '时长1':'Duration1',
  '电量2':'Energy2',
  '电费2':'Cost2',
  '时长2':'Duration2',
  '电量3':'Energy3',
  '电费3':'Cost3',
  '时长3':'Duration3',

  '新':'New',
  '查询网关日志失败':'Query GW log failed',
  '不设置':'Not Set',
  '按时间控制':'Time Control',
  '按温度控制':'Temp Control',
  '禁止开机控制':'Prohibit ON Control',
  '水机':'Chiller'

};

/**
 * @param {string} key - 中文原文
 * @returns {string} - 英文或中文
 */
export function t(key) {
  if (localStorage.getItem('lang') === '2') {
    return translations[key] || key;
  }
  return key;
}

/**
 * 批量翻译对象中的 key/label 等字段（用于表格表头、下拉选项等）
 * @param {Array|Object} data - 需要翻译的数据
 * @param {string} field - 要翻译的字段名，默认 'key'
 * @returns {Array|Object} - 翻译后的数据
 */
export function tData(data,field = 'key') {
  if (localStorage.getItem('lang') !== '2') {
    return data;
  }
  if (Array.isArray(data)) {
    return data.map(item => {
      if (item && typeof item === 'object' && item[field]) {
        return {...item,[field]:t(item[field])};
      }
      return item;
    });
  }
  return data;
}

/**
 * 双语显示函数（中文 + 英文）
 * 用于登录页面等需要同时显示中英文的场景
 * @param {string} key - 中文原文
 * @returns {string} - 中文 + 英文（换行显示）
 */
export function tBoth(key) {
  const en = translations[key] || key;
  if (localStorage.getItem('lang') === '2') {
    return key + '\n' + en;
  }
  return key;
}

export default {
  t,tBoth,tData
};



// WEBPACK FOOTER //
// ./src/config/i18n.js